import { request } from '../utils/request'
import { APIURLNEW } from '@/contants'

export function getRelationId (params = {scene: 'activity'}) {
  return request({
    url: '/agent/newUser/userRelation',
    params
  })
}

export function getUserInfo () {
  return request({
    url: '/agent/newUser/detail'
  })
}

export function getUserPid (params) {
  return request({
    url: '/agent/newUser/pid',
    params
  })
}

export function getTjb(params) {
  return request({
    url: '/score/web/yhTjb',
    params
  }, APIURLNEW)
}

export function getYyg (data) {
  return request({
    url: '/yh/yyg',
    method: 'post',
    data
  }, APIURLNEW)
}

export function checkPddAuth(params) {
  return request({
    url: '/yh/pddCheckAuth',
    params
  }, APIURLNEW)
}

export function createPddAuth(params) {
  return request({
    url: '/yh/pddCreateAuth',
    params
  }, APIURLNEW)
}